// extracted by mini-css-extract-plugin
module.exports = {"root":"AgreementModal_root__2KfuI","additionalInfo":"AgreementModal_additionalInfo__3cMh3"};